import Auth from "@/plugins/rhAuth/auth";

export default {
  install (Vue) {
    Vue.prototype.$rhAuth = new Auth();
  }
}
